export default __webpack_public_path__ + "static/Opengraph-0d434d78cae78d7c9d57e6544af00d17.jpg";